import { z } from 'zod';
import { SECTIONS } from './org.js';
import { customFieldViewSchema } from './field-access.js';
import { tenantSettingsSchema } from './tenant.js';
/** Ayar taşıyan modüller (Plan §7 module_settings; Ek A.3 modül ayar sekmeleri). */
export const MODULES = [
    'newsfeed',
    'leads',
    'opportunities',
    'proposals',
    'orders',
    'contracts',
    'activities',
    'tickets',
    'forms',
    'contacts',
    'companies',
    'products',
];
/**
 * Built-in alan kataloğu (Ek A.3'ten; M1'de çekirdek modüller, M2+ genişler).
 * "Bilgi giriş alanları" sekmesi: Göster/Zorunlu + varsayılana dön.
 */
export const BUILTIN_FIELD_CATALOG = {
    contacts: [
        { key: 'firstName', label: 'Ad', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'lastName', label: 'Soyad', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'relationType', label: 'İlişki tipi', defaultVisible: true, defaultRequired: true },
        { key: 'title', label: 'Ünvan', defaultVisible: true, defaultRequired: false },
        { key: 'company', label: 'Şirket', defaultVisible: true, defaultRequired: false },
        { key: 'phones', label: 'Telefon', defaultVisible: true, defaultRequired: false },
        { key: 'emails', label: 'E-posta', defaultVisible: true, defaultRequired: false },
        { key: 'addresses', label: 'Adres', defaultVisible: true, defaultRequired: false },
        { key: 'web', label: 'Web', defaultVisible: false, defaultRequired: false },
        { key: 'social', label: 'Sosyal', defaultVisible: false, defaultRequired: false },
        { key: 'gender', label: 'Cinsiyet', defaultVisible: false, defaultRequired: false },
        { key: 'details', label: 'Detaylar', defaultVisible: true, defaultRequired: false },
        { key: 'identityNo', label: 'Kimlik no', defaultVisible: false, defaultRequired: false },
        { key: 'taxOffice', label: 'Vergi dairesi', defaultVisible: false, defaultRequired: false },
        { key: 'paymentTerm', label: 'Ödeme vadesi', defaultVisible: false, defaultRequired: false },
        { key: 'iys', label: 'İYS izni', defaultVisible: false, defaultRequired: false },
        { key: 'specialDays', label: 'Özel günler', defaultVisible: true, defaultRequired: false },
        { key: 'files', label: 'Dosyalar', defaultVisible: true, defaultRequired: false },
    ],
    companies: [
        { key: 'name', label: 'Ad', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'relationType', label: 'İlişki tipi', defaultVisible: true, defaultRequired: false },
        { key: 'tradeName', label: 'İşletme adı', defaultVisible: false, defaultRequired: false },
        { key: 'phones', label: 'Telefon', defaultVisible: true, defaultRequired: false },
        { key: 'addresses', label: 'Adres', defaultVisible: true, defaultRequired: false },
        { key: 'emails', label: 'E-posta', defaultVisible: true, defaultRequired: false },
        { key: 'web', label: 'Web', defaultVisible: true, defaultRequired: false },
        { key: 'source', label: 'Kaynak', defaultVisible: true, defaultRequired: false },
        { key: 'sector', label: 'Sektör', defaultVisible: true, defaultRequired: false },
        { key: 'region', label: 'Bölge', defaultVisible: false, defaultRequired: false },
        { key: 'social', label: 'Sosyal', defaultVisible: false, defaultRequired: false },
        { key: 'details', label: 'Detaylar', defaultVisible: true, defaultRequired: false },
        { key: 'taxNo', label: 'Vergi no', defaultVisible: false, defaultRequired: false },
        { key: 'taxOffice', label: 'Vergi dairesi', defaultVisible: false, defaultRequired: false },
        { key: 'paymentTerm', label: 'Ödeme vadesi', defaultVisible: false, defaultRequired: false },
        { key: 'location', label: 'Konum', defaultVisible: false, defaultRequired: false },
        { key: 'firstContact', label: 'İlk kişi', defaultVisible: true, defaultRequired: false },
        { key: 'files', label: 'Dosyalar', defaultVisible: true, defaultRequired: false },
    ],
    leads: [
        { key: 'status', label: 'Durum', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'rating', label: 'Puanlama', defaultVisible: true, defaultRequired: false },
        { key: 'source', label: 'Kaynak', defaultVisible: true, defaultRequired: true },
        { key: 'fullName', label: 'Ad soyad', defaultVisible: true, defaultRequired: false },
        { key: 'title', label: 'Ünvan', defaultVisible: true, defaultRequired: false },
        { key: 'company', label: 'Şirket', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'phones', label: 'Telefon', defaultVisible: true, defaultRequired: false },
        { key: 'emails', label: 'E-posta', defaultVisible: true, defaultRequired: false },
        { key: 'sector', label: 'Sektör', defaultVisible: false, defaultRequired: false },
        { key: 'addresses', label: 'Adres', defaultVisible: false, defaultRequired: false },
        { key: 'details', label: 'Detaylar', defaultVisible: false, defaultRequired: false },
        { key: 'iys', label: 'İYS izni', defaultVisible: false, defaultRequired: false },
        { key: 'files', label: 'Dosyalar', defaultVisible: true, defaultRequired: false },
    ],
    opportunities: [
        {
            key: 'customer',
            label: 'Müşteri',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
        { key: 'subject', label: 'Konu', defaultVisible: true, defaultRequired: false },
        { key: 'contact', label: 'İlgili kişi', defaultVisible: true, defaultRequired: false },
        { key: 'amount', label: 'Tutar', defaultVisible: true, defaultRequired: true },
        { key: 'probability', label: 'Olasılık', defaultVisible: true, defaultRequired: false },
        { key: 'startDate', label: 'Başlangıç', defaultVisible: true, defaultRequired: false },
        {
            key: 'expectedCloseDate',
            label: 'Tahmini sonuçlanma',
            defaultVisible: true,
            defaultRequired: true,
        },
        { key: 'stage', label: 'Aşama', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'details', label: 'Detaylar', defaultVisible: true, defaultRequired: false },
        { key: 'pricingTable', label: 'Fiyat tablosu', defaultVisible: true, defaultRequired: false },
        {
            key: 'relatedRecords',
            label: 'İlgili kayıtlar',
            defaultVisible: true,
            defaultRequired: false,
        },
    ],
    proposals: [],
    orders: [],
    contracts: [],
    activities: [
        { key: 'type', label: 'Tip', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'name', label: 'Ad', locked: true, defaultVisible: true, defaultRequired: true },
        { key: 'assignees', label: 'Görevli', defaultVisible: true, defaultRequired: true },
        { key: 'priority', label: 'Öncelik', defaultVisible: false, defaultRequired: false },
        { key: 'dates', label: 'Başlama/bitiş', defaultVisible: true, defaultRequired: false },
        { key: 'repeat', label: 'Tekrar', defaultVisible: true, defaultRequired: false },
        { key: 'location', label: 'Konum', defaultVisible: false, defaultRequired: false },
        { key: 'subtasks', label: 'Yapılacak işler', defaultVisible: true, defaultRequired: false },
    ],
    // M4 WP 4.3 (keşif F12 çekmece formu). Ad soyad, konu, öncelik, detaylar ve görevli zorunlu ve kapatılamaz.
    tickets: [
        {
            key: 'requesterName',
            label: 'Ad soyad',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
        { key: 'requesterCompany', label: 'Şirket ismi', defaultVisible: true, defaultRequired: false },
        { key: 'requesterEmail', label: 'E-posta', defaultVisible: true, defaultRequired: false },
        { key: 'requesterPhone', label: 'Telefon', defaultVisible: true, defaultRequired: false },
        { key: 'relatedRecordId', label: 'Müşteri', defaultVisible: true, defaultRequired: false },
        { key: 'subject', label: 'Konu', locked: true, defaultVisible: true, defaultRequired: true },
        {
            key: 'assignees',
            label: 'Görevli',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
        {
            key: 'priority',
            label: 'Öncelik',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
        { key: 'typeKey', label: 'Tip', defaultVisible: true, defaultRequired: false },
        { key: 'categoryKey', label: 'Kategori', defaultVisible: true, defaultRequired: false },
        { key: 'sourceKey', label: 'Kaynak', defaultVisible: true, defaultRequired: false },
        {
            key: 'details',
            label: 'Detaylar',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
    ],
    forms: [],
    // WP 2.10: 12 alan (V30 `D` "alanlar (12)"); kategori zorunlu (F04 `D`), ad zorunlu değil (ad veya kod — K-3)
    products: [
        {
            key: 'category',
            label: 'Kategori',
            locked: true,
            defaultVisible: true,
            defaultRequired: true,
        },
        { key: 'name', label: 'Ad', defaultVisible: true, defaultRequired: false },
        { key: 'code', label: 'Kod', defaultVisible: true, defaultRequired: false },
        { key: 'brand', label: 'Marka', defaultVisible: true, defaultRequired: false },
        { key: 'model', label: 'Model', defaultVisible: true, defaultRequired: false },
        { key: 'unit', label: 'Ölçü birimi', defaultVisible: true, defaultRequired: false },
        { key: 'price', label: 'Satış fiyatı', defaultVisible: true, defaultRequired: false },
        { key: 'cost', label: 'Maliyet', defaultVisible: false, defaultRequired: false },
        { key: 'vat', label: 'KDV', defaultVisible: true, defaultRequired: false },
        { key: 'details', label: 'Detaylar', defaultVisible: true, defaultRequired: false },
        {
            key: 'image',
            label: 'Resim',
            defaultVisible: true,
            defaultRequired: false,
            noRequire: true,
        },
        {
            key: 'stock',
            label: 'Stok takibi',
            defaultVisible: true,
            defaultRequired: false,
            noRequire: true,
        },
    ],
    newsfeed: [],
};
export const builtinFieldSettingSchema = z.object({
    key: z.string().min(1).max(60),
    visible: z.boolean(),
    required: z.boolean(),
    sortOrder: z.number().int().min(0).max(1000),
});
export const builtinFieldsInputSchema = z
    .object({ fields: z.array(builtinFieldSettingSchema).max(100) })
    .strict();
/** Modül ayarları: serbest anahtar/değer (zod ile modül başına doğrulanır; M1'de ortak anahtar seti). */
export const moduleSettingsSchema = z
    .object({
    publishToFeed: z.boolean().default(true),
    referencePrefix: z.string().trim().max(10).default(''),
    referenceNextNo: z.number().int().min(1).default(1),
    requireOwner: z.boolean().default(true),
    allowOnlyForwardStage: z.boolean().default(false),
    extra: z
        .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()]))
        .prefault({}),
})
    .strict();
/** Haber akışı ayarları (yayınlama, haber akışında görünme, web bildirimi; modül başına). */
export const feedSettingsSchema = z
    .object({
    perModule: z.partialRecord(z.enum(MODULES), z.object({
        publish: z.boolean().default(true),
        showInFeed: z.boolean().default(true),
        webNotify: z.boolean().default(false),
    })),
    noteTags: z.array(z.string().trim().min(1).max(40)).max(20).default([]),
    agendaSections: z.array(z.string().trim().min(1).max(40)).max(10).default([]),
})
    .strict();
export const metadataResponseSchema = z.object({
    tenant: z.object({
        id: z.guid(),
        slug: z.string(),
        name: z.string(),
        metadataVersion: z.number().int(),
        aclVersion: z.number().int(),
    }),
    company: tenantSettingsSchema,
    modules: z.partialRecord(z.enum(MODULES), z.object({
        settings: moduleSettingsSchema,
        fields: z.array(builtinFieldSettingSchema.extend({ label: z.string(), locked: z.boolean() })),
    })),
    feed: feedSettingsSchema,
    sections: z.array(z.enum(SECTIONS)),
    /** Çağırana projekte özel alan tanımları (WP 2.8 K-6): yalnız okunabilir alanlar; principal listeleri ve
     *  `allowedRecordIds` yok; `writable` alan düzeyi yazma kararı. */
    customFields: z.array(customFieldViewSchema),
    generatedAt: z.string(),
});
export function defaultFieldSettings(module) {
    return BUILTIN_FIELD_CATALOG[module].map((f, i) => ({
        key: f.key,
        visible: f.defaultVisible,
        required: f.defaultRequired,
        sortOrder: i,
    }));
}
export function defaultFeedSettings() {
    const perModule = {};
    for (const m of MODULES)
        perModule[m] = { publish: true, showInFeed: true, webNotify: false };
    return { perModule, noteTags: [], agendaSections: [] };
}
//# sourceMappingURL=metadata.js.map